import RoleSelect from "./select.js"

RoleSelect.define()

export default RoleSelect
export * from './select.js';

/**
 * @type {import("./select-globals.js")}
 */
